import {RouterModule, Routes} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import {NgModule} from "@angular/core";
import {MsalGuard} from "@azure/msal-angular";
import {BrowserUtils} from "@azure/msal-browser";

const routes: Routes = [
    {
        path: 'logout',
        component: HomeComponent,
        data: {
            isLogout: true,
        }
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'cpo',
        loadChildren: () => import('./cpo/cpo.module').then(module => module.CpoModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'emp',
        loadChildren: () => import('./emp/emp.module').then(module => module.EmpModule),
        canActivate: [MsalGuard]
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: 'versionInfo',
        loadComponent: () => import('./component/version-info/version-info.component').then(c => c.VersionInfoComponent),
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: '/home',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
